import NinLogTypes from './types';

export const fetchNinLog = ({ page, size, q, operation, found }) => ({
  type: NinLogTypes.FETCH_NIN_LOG_START,
  data: { page, size, q, operation, found },
});

export const fetchNinLogSuccess = (payload) => ({
  type: NinLogTypes.FETCH_NIN_LOG_SUCCESS,
  payload,
});

export const fetchNinLogFailure = (error) => ({
  type: NinLogTypes.FETCH_NIN_LOG_FAILURE,
  payload: error,
});
